export default __webpack_public_path__ + "static/media/bg-2.d9a856a8.png";